let protocol = window.location.protocol;
let tdtToken="d7aab614275706f61db6a93b59c6014a";//天地图token,c6b646f2d0b02ff507effd9221b21c66
export default {
    tilesetUrl:"http://39.106.129.35:81/tileset/youtai/tileset.json",//模型url
    isGCJ02:true,//是否是火星坐标系统
    companyName:"友泰科技有限公司",
    ionToken:"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIyNzBlMTYxMC02YTkwLTQ5Y2EtOTU2NC1kNDUwYTg5ZGNjZTkiLCJpZCI6ODc0Mywic2NvcGVzIjpbImFzciIsImdjIl0sImlhdCI6MTU1MjY0MzE0NH0.1hZ8wb3Tq-58PXFaG9o-XPS0U7FmaOMr1qZocIEkIBM",
	initViewConfig:{//初始化视图位置配置
		longitude:118.0068086317,//经度wgs84
		latitude:37.4909539775,//纬度wgs84
		height:1500,//视角高度
        heading:0,//指向
        pitch:-90,//视角
        roll:0//旋转
	},
    ALTITUDE:36,//默认高度米
	LAYER:{
        BUILDING:"buildingLayer",//建筑物图层+标签
		WORKER:'workerLayer',//员工图层
        VEHICLE:"vehicleLayer",//车辆图层
		RISKAREA:"riskAreaLayer",//风险区域图层
        CAMERA:"cameraLayer",//摄像头图层
        WORKPERMIT:"workPermitLayer",//作业票图层
        ALARM:"alarmLayer",//报警图层
        DEVICE:"deviceLayer",//设备图层
        DANGER:"dangerLayer",//重大危险源图层
        STORE:"storeLayer",//仓库物资图层
        CPVGAS:"cpvGasLayer",//有毒气体图层
        EXGAS:"exGasLayer",//可燃气体图层
        GAUGE:"gaugeLayer",//液位图层
        TRACK:"trackLayer",//作业员与车辆轨迹图层
    },
    TILE:{//瓦片配置
        tiandituImg:{//影像
            url: `${protocol}//t{s}.tianditu.gov.cn/img_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=img&tileMatrixSet=w&TileMatrix={TileMatrix}&TileRow={TileRow}&TileCol={TileCol}&style=default&format=tiles&tk=${tdtToken}`,
            subdomains:['0','1','2','3','4','5','6','7'],
            layer: "tdtImgLayer",
            style: "default",
            format: "image/jpeg",
            maximumLevel:18,
            tileMatrixSetID: "GoogleMapsCompatible",//使用谷歌的瓦片切片方式
            show: true
        },
        tiandituCia:{//注记
            url: `${protocol}//t{s}.tianditu.gov.cn/cia_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=cia&tileMatrixSet=w&TileMatrix={TileMatrix}&TileRow={TileRow}&TileCol={TileCol}&style=default&format=tiles&tk=${tdtToken}`,
            subdomains:['0','1','2','3','4','5','6','7'],
            layer: "tdtCiaLayer",
            style: "default",
            format: "image/jpeg",
            maximumLevel:18,
            tileMatrixSetID: "GoogleMapsCompatible",
            show: true
        }
    }
};
